import styles from './StatusBadge.module.css';

export type BadgeVariant = 'success' | 'warning' | 'info' | 'muted' | 'primary';

interface StatusBadgeProps {
  variant: BadgeVariant;
  label: string;
}

export default function StatusBadge({ variant, label }: StatusBadgeProps) {
  return (
    <span className={styles.badge} data-variant={variant}>
      <span className={styles.dot} />
      {label}
    </span>
  );
}
